// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YlTzJFsjVIBwNY {
  box-sizing: border-box;
  width: 272px;
  padding: var(--ds-space-150, 12px);
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--tr-background-list);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
`, ""]);
// Exports
export var limitMessage = `YlTzJFsjVIBwNY`;
export default ___CSS_LOADER_EXPORT___;
